import { ITeacherState } from "../models/interfaces";
import { TeacherActionTypes } from "../models/teacherActions";
import { GET_TEACHER } from "../types";

export default (teacher: ITeacherState = null, action: TeacherActionTypes): ITeacherState => {
    switch (action.type) {
        case GET_TEACHER:
            return action.payload;
        default:
            return teacher;
    }
};
